import { useState, useCallback, useEffect } from 'react';

const useTableScroll = () => {
    const [tableChild, setTableChild] = useState<HTMLDivElement>();
    const [tableScroll, setTableScroll] = useState<number>(0);

    const onTableMounted = useCallback((node: HTMLDivElement) => {
        if (node) {
            setTableChild(node.getElementsByClassName('rt-table-container')[0] as HTMLDivElement);
        }
    }, []);

    useEffect(() => {
        const updateTableScroll = () => {
            tableChild && setTableScroll(Math.min(tableChild.scrollLeft, 32));
        };

        tableChild?.addEventListener('scroll', updateTableScroll);

        return () => {
            tableChild?.removeEventListener('scroll', updateTableScroll);
        };
    }, [tableChild]);

    return {
        tableChild,
        onTableMounted,
        tableScroll,
    };
};

export default useTableScroll;
